module.exports = __webpack_public_path__ + "media/images/klaviyo-ee7ff160fcb0f786c52bdbeab3db1b74.svg";